import { render, staticRenderFns } from "./step-banorte.vue?vue&type=template&id=7f9bc478&scoped=true"
import script from "./step-banorte.vue?vue&type=script&setup=true&lang=ts"
export * from "./step-banorte.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./step-banorte.vue?vue&type=style&index=0&id=7f9bc478&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9bc478",
  null
  
)

export default component.exports